var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"product-code",class:{'product-code--adaptive': _vm.isAdaptive}},[_c('meta',{attrs:{"itemprop":"sku","content":_vm.code}}),_vm._v(" "+_vm._s(_vm.$t('product_code') + ' ' + _vm.code)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }